export default __webpack_public_path__ + "b9ac0b22128503dcccdcab760cfaea90.svg";